import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';

export type NewsPreference = {
  id: string;
  name: string;
  description?: string;
  subscribed: boolean;
};

/**
 * Kategórie noviniek s tým, či ich používateľ odoberá. Od migrácie 000025 sú
 * kategórie ploché (sedem koreňov), takže tu už nie je strom.
 */
export const getUserNewsPreferences = createQueryFn(
  QueryNameSpace.getUserNewsPreferences,
  async (): Promise<NewsPreference[]> => {
    const [{ news_categories: newsCategories = [] }, { subscriptions = [] }] =
      await Promise.all([
        DigiobcanApi.getNewsCategories({ view: 'flat' }),
        DigiobcanApi.meGetNewsCategories(),
      ]);

    return newsCategories.map((category) => ({
      id: category.category_id,
      name: category.name,
      description: category.description,
      subscribed: subscriptions.includes(category.category_id),
    }));
  },
);
